import { useNavigate } from 'react-router-dom';
import { toaster } from '@optiaxiom/react';
import { useMutation } from '@tanstack/react-query';

import { useInstanceId } from '@frontend/hooks';
import { buildMessagesPath } from '@frontend/utils/messagingUrl';

import { createDMConversation } from '../services/messagingService';

/** Opens (or creates) a DM with the given OptiID user id and navigates there. */
export function useOpenDirectMessage() {
  const navigate = useNavigate();
  const { instanceId } = useInstanceId();

  return useMutation({
    mutationFn: (participantId: string) => createDMConversation(participantId),
    onSuccess: conversation => {
      navigate(`/instances/${instanceId}${buildMessagesPath({ conversationId: conversation.id })}`);
    },
    onError: () => {
      toaster.create('Failed to open chat', { type: 'danger' });
    },
  });
}
